import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpParams } from '@angular/common/http';

// Service

// Interface
import { IServerSide } from '@/shared/components/general/table-generic/interface/table-generic.interface';
import { IDataPagination } from '@/interface/general/IPagination';
import {
  IResponseApiGeneric,
  IResponseApiGenericSS,
} from '@/interface/general/IResponseApi';

import { KeyValueArrayGeneric } from '@/interface/general/params.interface';

// Abstract
import { GeneralAbstract } from '@/abstract/general.abstract';
import { IConfiguracionSistema } from '../../interfaces/flujo-doc-procesos.interface';
import { IFiltroDistribuirDocumento } from '../interfaces/distribuir-documentos.interface';
import { IplayLoad } from '../interfaces/comprobantes-egreso.interface';

@Injectable({
  providedIn: 'root',
})
export class GeneralService<T> extends GeneralAbstract<T> {
  // Data para la Tablet Generic
  dataTableGenericSubject$ = new Subject<IDataPagination<IServerSide>>();

  //URL
  override baseUrl = 'FlujoDocRad';
  override urlGetById = 'FlujoDocRad/GetById?Id=';
  override urlGetAll = 'FlujoDocRad/GetAll';
  override urlGetInitialData = 'FlujoDocRad/GetInitialData';
  override urlPostCreate = 'FlujoDocRad/TerminarRadicado';
  override urlPutUpdate = 'FlujoDocRad/AnularRadicado';
  urlPutReply = 'FlujoDocRad/UpdateData';
  override urlDelete = 'FlujoDocRad/AnularRadicado?CodRadicado=';
  private urlProcesoPaso = 'FlujoDoc/GetProceso_O_Paso';
  private urlPutSelectProg = 'FlujoDocRad/UpdateSelectProgPagos';
  //Pasos Procesar
  private urlPost = 'FlujoDocRad/PasosDistribuirProcesar';
  private urlPostfdArchivosPasosAuditarProcesar =
    'FlujoDoc/fdArchivosPasosAuditarProcesar';
  // Cargue Masivo
  private urlTraerInfoCargueMasivo = 'CargueMasivoFlujoDoc/UpdateInfoErpDocMasivo';
  private urlEvacuarCargueMasivo = 'CargueMasivoFlujoDoc/EvacuarDocMasivo';
  private urlDeleteCargueMasivo = 'CargueMasivoFlujoDoc/BorrarDocMasivo';

  /**
   * Metodo para crear el registro
   * @param data
   * @returns respuesta del backend
   */
  post(data: T): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Post<IResponseApiGeneric<T>>(
      data,
      this.urlPostCreate,
    );
  }

  postProcesosOPasos(data: T): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Post<IResponseApiGeneric<T>>(
      data,
      this.urlProcesoPaso,
    );
  }
  /**
   * Metodo para crear el registro
   * @param data
   * @returns respuesta del backend
   */
  postWithUrl(data: T, url: string): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Post<IResponseApiGeneric<T>>(data, url);
  }

  /**
   * Actualizamos
   * @param data Parametros a actualizar
   * @returns respuesta
   */
  override put(data: T): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Put<IResponseApiGeneric<T>>(
      data,
      this.urlPutUpdate,
    );
  }

  /**
   * Actualizamos recibiendo la url
   * @param data Parametros a actualizar
   * @returns respuesta
   */
  putWithUrl(data: T, url: string): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Put<IResponseApiGeneric<T>>(data, url);
  }

  /**
   * Eliminamos un registros
   * @param CodRadicado Radicado a eliminar
   * @returns respuesta
   */
  delete(CodRadicado: string | number) {
    return this.httpService.Delete<IResponseApiGeneric<T>>(
      this.urlDelete + `${CodRadicado}`,
    );
  }

  /**
   * Eliminamos un registros
   * @param CodRadicado Radicado a eliminar
   * @returns respuesta
   */
  deleteWithUrl(CodRadicado: string | number, url: string) {
    return this.httpService.Delete<IResponseApiGeneric<T>>(
      url + `${CodRadicado}`,
    );
  }

  //#region Cargue Masivo

  //Traer Informacion
  TraerInfoCargueMasivo(data: T): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Post<IResponseApiGeneric<T>>(
      data,
      this.urlTraerInfoCargueMasivo,
    );
  }

  //Evacuar
  EvacuarCargueMasivo(data: { strstrvectorMasivoChecks: string }) {
    return this.httpService.Post(data, this.urlEvacuarCargueMasivo);
  }

  //Borrar
  deleteCargueMasivo(data: {
    strstrvectorMasivoChecks: string;
    strstrvectorMasivoNOChecks: string;
  }) {
    return this.httpService.Post(data, this.urlDeleteCargueMasivo);
  }

  //#endregion
  /**
   * Obtenemos los parametros iniciales
   * @returns
   */
  override getInitialParameters(): Observable<
    IResponseApiGeneric<IConfiguracionSistema>
  > {
    return this.httpService.Get<IResponseApiGeneric<IConfiguracionSistema>>(
      this.urlGetInitialData,
    );
  }

  //buscar id
  getQueryById(id: number): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Get<IResponseApiGeneric<T>>(
      `${this.urlGetById}${id}`,
    );
  }

  //buscar id
  getByUrlComplete(url: string): Observable<IResponseApiGeneric<T>> {
    return this.httpService.GetWithUrlComplete<IResponseApiGeneric<T>>(url);
  }

  getWitchParams(
    datos: KeyValueArrayGeneric<string | number>,
  ): Observable<IResponseApiGenericSS<T>> {
    const params = this.dynamicParams(datos);
    // El any se remplaza por la interface de la estructura que te devuelve la BD
    // ej: return this.httpService.GetParams<IResponseListFilesParams>
    return this.httpService.GetParams<IResponseApiGenericSS<T>>(
      this.urlGetInitialData,
      params,
    );
  }

  getWitchHttpParams(
    datos: KeyValueArrayGeneric<string | number>,
  ): Observable<IResponseApiGenericSS<IConfiguracionSistema>> {
    const params = this.dynamicParams(datos);
    // El any se remplaza por la interface de la estructura que te devuelve la BD
    // ej: return this.httpService.GetParams<IResponseListFilesParams>
    return this.httpService.GetParams<
      IResponseApiGenericSS<IConfiguracionSistema>
    >(this.urlProcesoPaso, params);
  }

  getWitchParamsAndUrl(
    datos: KeyValueArrayGeneric<string | number | null | undefined>,
    url: string,
  ): Observable<IResponseApiGenericSS<T>> {
    const params = this.dynamicParams(datos);
    return this.httpService.GetParams<IResponseApiGenericSS<T>>(url, params);
  }

  dynamicParams(filtros: KeyValueArrayGeneric): HttpParams {
    let params = new HttpParams();

    // Iteramos sobre cada elemento del array de filtros
    filtros.forEach(({ key, value }) => {
      // Solo agregamos los parámetros que tienen valor y no son null/undefined
      if (value !== null && value !== undefined && value !== '') {
        // Convertimos el valor a string (necesario para HttpParams)
        const stringValue = String(value);
        params = params.append(key, stringValue);
      }
    });

    return params;
  }

  putFlujoDocRad(data: T): Observable<IResponseApiGeneric<T>> {
    return this.httpService.Put<IResponseApiGeneric<T>>(
      data,
      this.urlPutSelectProg,
    );
  }
  //#region  PasosDistribuirProcesar
  postPasosDistribuir(data: Partial<IFiltroDistribuirDocumento>) {
    return this.httpService.Post<IResponseApiGeneric<string>>(
      data,
      this.urlPost,
    );
  }
  //#endregion

  //#region  fdArchivosPasosAuditarProcesar
  postfdArchivosPasosAuditarProcesar(payload: IplayLoad) {
    return this.httpService.Post<IResponseApiGeneric<string>>(
      payload,
      this.urlPostfdArchivosPasosAuditarProcesar,
    );
  }
  //#endregion
}
